document.addEventListener('DOMContentLoaded', () => {
  const bodyEl = document.body;
  const btnText = document.querySelector('.l-main-header .c-btn-text');
  const dropdownItems = document.querySelectorAll('.l-main-header .dropdown-item');
  dropdownItems.forEach(item => {
    item.addEventListener('click', () => {
      const sizeText = item.textContent.trim();
      bodyEl.classList.remove('font-small', 'font-medium', 'font-large');
      btnText.textContent = sizeText;
      if (sizeText === '小') {
        bodyEl.classList.add('font-small');
      } else if (sizeText === '中') {
        bodyEl.classList.add('font-medium');
      } else {
        bodyEl.classList.add('font-large');
      }
    });
  });
  const mainHeader = document.querySelector('.l-main-header .c-header-wrapper');
  const collapseEl = document.getElementById('mainNavbar');

  collapseEl.addEventListener('show.bs.collapse', () => {
    mainHeader.classList.add('show-bg');
  });
  collapseEl.addEventListener('hide.bs.collapse', () => {
    mainHeader.classList.remove('show-bg');
  });

  const bsCollapse = new bootstrap.Collapse('#mainNavbar', {
    toggle: false
  })

  const mobileMenuBtns = document.querySelectorAll('.c-navbar-nav-link');

  mobileMenuBtns.forEach((el) => {
    el.addEventListener('click', (event) => {
      bsCollapse.hide();
    })
  })
});
